(() => {
  const stateClass = 'dhajia-mobile-menu-open';

  const injectDesktopHeaderContrastFix = () => {
    if (document.getElementById('dhajia-desktop-header-contrast-fix')) return;
    const style = document.createElement('style');
    style.id = 'dhajia-desktop-header-contrast-fix';
    style.textContent = `
      @media screen and (min-width:1100px){
        .template-index .shopify-section-header.header-overlay:not(.shopify-section-header-sticky) .header--left-logo-second .header__inline-menu{
          background:rgba(247,240,223,.96)!important;
          border:1px solid rgba(6,59,53,.12)!important;
          box-shadow:0 10px 30px rgba(7,30,27,.12)!important;
          -webkit-backdrop-filter:blur(10px);
          backdrop-filter:blur(10px);
        }
        .template-index .shopify-section-header.header-overlay:not(.shopify-section-header-sticky) .header--left-logo-second .header__inline-menu .header__menu-item,
        .template-index .shopify-section-header.header-overlay:not(.shopify-section-header-sticky) .header--left-logo-second .header__inline-menu .list-menu-item--active > a{
          color:#063b35!important;
        }
        .template-index .shopify-section-header.header-overlay:not(.shopify-section-header-sticky) .header--left-logo-second .header__inline-menu .header__menu-item svg{
          color:#c98a52!important;
        }
        .template-index .shopify-section-header.header-overlay:not(.shopify-section-header-sticky) .header--left-logo-second .header__inline-menu .list-menu-item:hover > .header__menu-item,
        .template-index .shopify-section-header.header-overlay:not(.shopify-section-header-sticky) .header--left-logo-second .header__inline-menu .list-menu-item:focus-within > .header__menu-item{
          color:#c98a52!important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  injectDesktopHeaderContrastFix();

  const getDrawerDetails = (scope = document) =>
    scope.querySelector?.('header-drawer > details') ||
    document.querySelector('header-drawer > details');

  const syncDrawerState = () => {
    const details = getDrawerDetails();
    const header = document.querySelector('.shopify-section-header');
    const isOpen = Boolean(details?.hasAttribute('open'));

    document.documentElement.classList.toggle(stateClass, isOpen);

    if (!header) return;
    header.classList.toggle(stateClass, isOpen);

    if (isOpen) {
      header.classList.remove('shopify-section-header-hidden');
      header.classList.add('shopify-section-header-sticky');
    }
  };

  const observeDrawer = (scope = document) => {
    const details = getDrawerDetails(scope);
    if (!details) {
      syncDrawerState();
      return;
    }

    if (!details.dataset.dhajiaMenuObserved) {
      details.dataset.dhajiaMenuObserved = 'true';
      new MutationObserver(syncDrawerState).observe(details, {
        attributes: true,
        attributeFilter: ['open', 'class'],
      });
      details.addEventListener('toggle', syncDrawerState);
    }

    syncDrawerState();
  };

  const init = () => observeDrawer(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    injectDesktopHeaderContrastFix();
    observeDrawer(event.target);
  });
  window.addEventListener('pageshow', syncDrawerState);
})();
